import React from 'react';
import { useRoleAccess } from '../hooks/useRoleAccess';
import type { Role } from '../constants/roles';
import { Button } from '@/components/ui/button';
import { ROLES } from '@/features/auth/constants/roles';
import { Link } from 'react-router-dom';
import { TableCell } from '@/components/ui/table';
import { BrowserCompatWrapper } from '@/components/ui/BrowserCompatWrapper';

interface RoleBasedElementProps {
  children: React.ReactNode;
  requiredRoles: Role | Role[];
  fallback?: React.ReactNode;
  establishment?: { id: string | number };
}

/**
 * Component to render elements based on user roles
 * Provides a declarative way to show conditional content
 */
export const RoleBasedElement: React.FC<RoleBasedElementProps> = ({
  children,
  requiredRoles,
  fallback = null,
  establishment
}) => {
  const { hasRole } = useRoleAccess();

  if (!hasRole(requiredRoles)) {
    return fallback ? <BrowserCompatWrapper>{fallback}</BrowserCompatWrapper> : null;
  }

  return <BrowserCompatWrapper>{children}</BrowserCompatWrapper>;
};

// Usage example:
// <TableCell>
//   <RoleBasedElement 
//     requiredRoles={[ROLES.ADMIN, ROLES.FISCALIZACION_EDITOR, ROLES.FISCALIZACION_LECTOR]}
//     fallback={
//       <Button variant="outline" size="sm" disabled>
//         No access
//       </Button>
//     }
//     establishment={establishment}
//   >
//     <Link to={`/accommodation/${establishment?.id}`}>
//       <Button variant="secondary" size="sm">View Details</Button>
//     </Link>
//   </RoleBasedElement>
// </TableCell> 